// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { useCallback } from 'react';
import { createPath, useNavigate as useNavigateBase, To, NavigateOptions } from 'react-router';

const useNavigate = () => {
    const navigateBase = useNavigateBase();

    return useCallback((to: To, options: NavigateOptions = {}) => {
        if (!require('routes').isClientSideRedirectAllowed(to)) {
            window.location[options?.replace ? 'replace' : 'assign'](typeof to === 'object' && to !== null ? createPath(to) : to);
        } else {
            navigateBase(to, options);
        }
    }, [navigateBase]);
};

export default useNavigate;
